import { render } from "./index.vue?vue&type=template&id=28593d02&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=28593d02&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/LabSolver/LabSolver/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28593d02"]])

export default __exports__